import { render, staticRenderFns } from "./BindWithdrawAcc.vue?vue&type=template&id=9c151770&scoped=true&"
import script from "./BindWithdrawAcc.vue?vue&type=script&lang=js&"
export * from "./BindWithdrawAcc.vue?vue&type=script&lang=js&"
import style0 from "./BindWithdrawAcc.vue?vue&type=style&index=0&id=9c151770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c151770",
  null
  
)

export default component.exports